import React, { FC, PropsWithChildren } from 'react'
import logoIcon from '../../assets/icons/logo-icon.png'

const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='min-h-screen flex flex-col items-center overflow-auto justify-center bg-[linear-gradient(180deg,_#DFE3F7_0%,_#E8F4FF_100%)] py-6'>
      <img src={logoIcon} className='mb-8' />
      {children}
    </div>
  )
}

export default AuthLayout
